import { ChildrenAlertsTypes } from 'store/schoolDistricts';

export const getAlertTranslationSlug = (name) => {
  return {
    [ChildrenAlertsTypes.MISSING_ASSIGNMENT]: 'SCHOOL_DISTRICTS.ASSIGMENT_PREVIEW.VALUES.MISSING_ASSIGNMENT',
    [ChildrenAlertsTypes.MISSING_TERYT]: 'SCHOOL_DISTRICTS.ASSIGMENT_PREVIEW.VALUES.MISSING_TERYT',
  }[name];
};
